/* Angular Component */
import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "ichannel-link",
  templateUrl: "./link.component.html",
  styleUrls: ["./link.component.scss"],
})
export class LinkComponent {
  @Input()
  name;

  @Input()
  link;

  @Input()
  iconClass = "";

  @Input("is-sub-menu-link") isSubMenuLink: boolean = false;

  constructor(public router: Router) {}
  ngOnInit() {
    if (!this.iconClass && this.isSubMenuLink) {
      this.iconClass = "fa fa-caret-down";
    }
  }
  isRouterPartOfSubMenu() {
    return this.isSubMenuLink && this.router.url.includes(this.link);
  }
}
